import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/app/(marketing)/_PageSections/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer.tsx");
